import * as React from "react";
import type { SVGProps } from "react";
const SvgBoat = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M3.494 16C2.408 13.493 2 10 2 10h20s-.794 3.493-2.835 6"
    />
    <path
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M6 5h8v5H6z"
    />
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M1 20s1.499-1 2.625-1 1.499 1 2.625 1 1.499-1 2.625-1 1.499 1 2.625 1 1.499-1 2.625-1 1.499 1 2.625 1 1.499-1 2.625-1 1.499 1 2.625 1"
    />
  </svg>
);
export default SvgBoat;
